import React, { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import "./HologramDetail.css";
import swal from "sweetalert";

const HologramDetail = () => {
  const [data, setData] = useState([]);
  const [inputValues, setInputValues] = useState([]);
  const [inputEntered, setInputEntered] = useState(false);

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getHologram").then(
      (response) => {
        const reversedData = response.data.reverse();
        setData(reversedData);
        const initialValues = reversedData.map(() => ({
          used: 0,
          damaged: 0,
        }));
        setInputValues(initialValues);
      }
    );
  }, []);

  const handleInputChange = (index, column, value) => {
    const newInputValues = [...inputValues];
    newInputValues[index][column] = value;

    const initialQuantity = data[index].Quantity;
    newInputValues[index].damaged = initialQuantity - value;

    setInputValues(newInputValues);
    setInputEntered(true);
  };

  const updateHologram = (id, used, damaged) => {
    if (!inputEntered) {
      swal({
        title: "Input Required",
        text: "Please enter values in the input fields before updating.",
        icon: "warning",
      });
      return;
    }

    Axios.put(`https://nodei.ssccglpinnacle.com/puthologram/${id}`, {
      used: used,
      damaged: damaged,
    })
      .then(() => {
        console.log("Updated successfully");
        swal({
          title: "Details Saved",
          text: "",
          icon: "success",
        });
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="holo-container">
      <h2 style={{ textAlign: "center" }}>Holograms</h2>

      <Table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "center",
          margin: "20px 0",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#007bff", color: "#fff" }}>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>
              Dispatched Date
            </th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>
              Quantity
            </th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>
              Serial Number
            </th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>
              Correct Holograms
            </th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>
              Damaged
            </th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr
              key={row.orderno}
              style={{
                border: "1px solid #ddd",
                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
              }}
            >
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {new Date(row.Date).toLocaleDateString("en-US", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {row.Quantity}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {row.StartingNo}-{row.EndingNo}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                <input
                  type="number"
                  value={inputValues[index]?.used}
                  onChange={(e) =>
                    handleInputChange(index, "used", parseInt(e.target.value))
                  }
                  style={{
                    width: "90px",
                    textAlign: "center",
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                <input
                  type="number"
                  value={inputValues[index]?.damaged}
                  disabled
                  style={{
                    width: "90px",
                    textAlign: "center",
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    backgroundColor: "#eee",
                  }}
                />
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                <button
                  onClick={() => {
                    const updatedUsed = inputValues[index]?.used;
                    const updatedDamaged = inputValues[index]?.damaged;
                    updateHologram(row._id, updatedUsed, updatedDamaged);
                  }}
                  style={{
                    padding: "6px 14px",
                    border: "none",
                    backgroundColor: "#28a745",
                    color: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Update
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default HologramDetail;
